import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { firstPayLevel } from "@/api/data";
import serverList from "../../../components/serverList/serverOptions.vue";
import VxeTable from "@/components/vxeTable/vxeTable.vue";
import DataOptions from "../../../components/timeList/dataOptions.vue";
export default {
  name: "firstPayLevel",
  components: {
    serverList: serverList,
    VxeTable: VxeTable,
    DataOptions: DataOptions
  },
  data: function data() {
    var _this = this;
    var h = this.$createElement;
    return {
      searchInfo: {
        server_id: [],
        role_type: 0
      },
      options: [{
        label: "全部角色",
        value: 0
      }, {
        label: "新角色",
        value: 1
      }, {
        label: "滚服角色",
        value: 2
      }],
      type: 0,
      timedata: [this.$moment().subtract(7, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")],
      tableData: [],
      tableColumn: [{
        field: "roleFirstPayLevel",
        title: "角色首次付费等级",
        sortable: true
      }, {
        field: "cnt",
        title: "人数",
        sortable: true
      }, {
        field: "total_fee",
        title: "充值金额",
        sortable: true,
        slots: {
          default: function _default(_ref) {
            var row = _ref.row;
            return [h("span", [row.total_fee, " \u5143"])];
          }
        }
      }, {
        field: "aaa",
        title: "人均充值金额",
        sortable: true,
        slots: {
          default: function _default(_ref2) {
            var row = _ref2.row;
            return [h("span", [_this.cal.toDecimal2(row.total_fee / row.cnt), "\u5143"])];
          }
        }
      }]
    };
  },
  methods: {
    queryEvent: function queryEvent() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.searchInfo.sdate = _this2.timedata[0];
              _this2.searchInfo.edate = _this2.timedata[1];
              _this2.searchInfo.role_type = _this2.type;
              _context.next = 5;
              return firstPayLevel(_this2.searchInfo);
            case 5:
              res = _context.sent;
              if (!res.data.list || res.data.list.length == 0) {
                _this2.tableData = [];
                _this2.$message({
                  message: "暂无数据",
                  type: "warning"
                });
              } else {
                _this2.tableData = res.data.list;
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};